import { AppBar as BaseAppBar } from 'react-admin'
import appLogo from '../assets/logo_lgs.png'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontWeight: 600,
    letterSpacing: '0.02em',
  },
  logo: {
    maxWidth: '88px',
    marginRight: 12,
    filter: 'brightness(0) invert(1)',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
  },
})

const AppBar = props => {
  const classes = useStyles()
  return (
    <BaseAppBar {...props}>
      <div className={classes.brand}>
        <img src={appLogo} alt="Let's Go Surveys" className={classes.logo} />
        <Typography
          variant="h6"
          color="inherit"
          className={classes.title}
          id="react-admin-title"
        />
      </div>
    </BaseAppBar>
  )
}

export default AppBar
